import { flexRender } from "@tanstack/react-table";
import type { Table } from "shared/react-table/appTable";
import { useNavigate } from "@tanstack/react-router";

import { TableRow, TableCell } from "components/table";
import { useTranslation } from "react-i18next";
import { SkeletonRows } from "components/table/SkeletonRows";
import { SearchTerm } from "integrations/firebase/collections/searchTerms";
import { ChevronRight } from "lucide-react";
import { routePath } from "../../../shared/constants";

export const SearchTermsAmazonTableBody = ({
  table,
  isLoading,
}: {
  table: Table<SearchTerm>;
  isLoading: boolean;
}) => {
  const { t } = useTranslation(["searchTerms"]);
  const columns = table.getAllColumns();
  const navigate = useNavigate();

  if (isLoading) {
    return <SkeletonRows columns={columns} />;
  }

  const { rows } = table.getRowModel();

  if (!rows.length) {
    return (
      <TableRow>
        <TableCell colSpan={columns.length + 1} className="h-24 text-center">
          {t("searchTerms:noResults")}
        </TableCell>
      </TableRow>
    );
  }

  return (
    <>
      {rows.map((row) => (
        <TableRow
          key={row.id}
          className="group"
          onClick={() => {
            navigate({
              to: "/books",
              search: {
                q: row.getValue<string>("term"),
                type: "semantic",
                pageSize: "50",
              },
              state: { from: routePath("/search-terms/amazon") },
            });
          }}
        >
          {row.getVisibleCells().map((cell) => (
            <TableCell
              key={cell.id}
              style={{ width: cell.column.getSize() || undefined }}
            >
              {flexRender(cell.column.columnDef.cell, cell.getContext())}
            </TableCell>
          ))}
          <TableCell className="w-10 pr-4 text-right">
            <ChevronRight className="inline-block h-4 w-4 text-secondary-400 opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
          </TableCell>
        </TableRow>
      ))}
    </>
  );
};
